export default "__VITE_ASSET__CbOuMxjf__";